import { BikeTypeV2, FrameContractDTO } from "@jobrad-gmbh/bike-leasing-calculator";
import { CalculatorEnv } from "../configuration";
import { InputDataUIModel } from "../../../components";

export enum CalculationActionTypes {
  INIT = "INIT",
  CALCULATE = "CALCULATE",
  RESET_RESULTS = "RESET_RESULTS",

  CHANGE_BIKE_TYPE_SELECTION = "CHANGE_BIKE_TYPE_SELECTION",
  SHOW_RESULTS_DETAILS = "SHOW_RESULTS_DETAILS",
  CHANGE_ARBEITNEHMER_TYP = "CHANGE_ARBEITNEHMER_TYP",
}

export type InitCalculatorPayload = { frameContract: FrameContractDTO; calculatorEnv: CalculatorEnv };
type InitCalculatorAction = {
  type: CalculationActionTypes.INIT;
  payload: InitCalculatorPayload;
};

type CalculateResultsAction = {
  type: CalculationActionTypes.CALCULATE;
  payload: Partial<InputDataUIModel>;
};

type ResetResultsAction = {
  type: CalculationActionTypes.RESET_RESULTS;
};

type ChangeArbeitnehmerTypAction = {
  type: CalculationActionTypes.CHANGE_ARBEITNEHMER_TYP;
  payload: "beamte" | "angestellte";
};

type ChangeBikeTypeSelectionAction = {
  type: CalculationActionTypes.CHANGE_BIKE_TYPE_SELECTION;
  payload: BikeTypeV2;
};

type ShowResultsDetailsAction = {
  type: CalculationActionTypes.SHOW_RESULTS_DETAILS;
  payload: boolean;
};

type CalculationAction =
  | InitCalculatorAction
  | CalculateResultsAction
  | ResetResultsAction
  | ChangeBikeTypeSelectionAction
  | ShowResultsDetailsAction
  | ChangeArbeitnehmerTypAction;

export type {
  InitCalculatorAction,
  CalculateResultsAction,
  ResetResultsAction,
  CalculationAction,
  ChangeBikeTypeSelectionAction,
  ShowResultsDetailsAction,
  ChangeArbeitnehmerTypAction,
};
